var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClickTouch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7955 12.8744L21.7952 12.8738L19.3598 8.6683C18.9454 7.95274 18.0298 7.70804 17.3137 8.12148L17.2494 8.15858C16.5985 8.53441 16.3566 9.34608 16.6786 10.0115L15.9051 8.67187C15.4909 7.95443 14.5735 7.70862 13.8561 8.12284C13.1386 8.53705 12.8928 9.45443 13.307 10.1719L13.0994 9.81217C12.6852 9.09473 11.7678 8.84892 11.0503 9.26314C10.3329 9.67735 10.0871 10.5947 10.5013 11.3122L7.5013 6.11602C7.08708 5.39858 6.1697 5.15277 5.45226 5.56698C4.73482 5.98119 4.48901 6.89858 4.90322 7.61602L10.0613 16.5501C10.1503 16.7042 10.0088 16.889 9.83684 16.8434L8.31701 16.4404C7.51692 16.2282 6.6971 16.7053 6.4833 17.5033L6.96626 17.6327L6.4833 17.5033C6.26805 18.3066 6.74471 19.1136 7.50891 19.3633C8.00543 19.5256 8.5479 19.7189 9.1195 19.9225C10.3877 20.3743 11.7994 20.8772 13.1707 21.2061C15.1611 21.6834 17.2528 21.8479 18.9164 20.8875L19.7824 20.3875C22.413 18.8687 23.3143 15.505 21.7955 12.8744Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.10966 12.6896C2.24354 11.9216 0.542655 8.97562 1.31063 6.1095C2.0786 3.24337 5.02462 1.54249 7.89075 2.31046C9.81029 2.82481 11.2072 4.3161 11.6898 6.10605",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClickTouch);
export default __webpack_public_path__ + "static/media/click-touch.46743db304da9f95c6af06ab34a36532.svg";
export { ForwardRef as ReactComponent };